import React from 'react';
import { RoadmapDeliverableWrapperLayout } from 'Views/Page/Content/Templates/WizardTemplates/RoadmapDeliverable/Wrapper/RoadmapDeliverableWrapperLayout';
import {
  FDAlert, FDPaper,
  FDStack,
} from '@facet-wealth/design';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import history from 'State/history';
import { dashboardUri } from 'Consts/clientUris';
import RoadmapDeliverableTimeline
  from 'Views/Page/Content/Templates/WizardTemplates/RoadmapDeliverable/WelcomeToYourRoadmapStepTemplate/RoadmapDeliverableTimeline';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import NextMeetingScheduleInfo from 'Views/Page/Content/Templates/MeetingInfoOutroStep/NextMeetingScheduleInfo';
import { openModal } from 'Helpers/ModalHelper';
import modalConsts from 'Consts/ModalNames';
import fr from 'facet-rest';
import { useMeetingBooked } from 'Hooks/useRefreshEvent';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import { dataAttrs } from 'Helpers/Testing';

const Layout = () => {
  const { resource } = useMetaLayoutContext();
  const { refreshPageContentCollection } = usePageContentContext();

  useMeetingBooked(async () => {
    refreshPageContentCollection();
  });

  if (!resource) {
    return null;
  }

  const goToDashboard = () => {
    history.push(dashboardUri);
  };

  const scheduleMeetingRel = resource.withRelationship(fr.relationships.scheduleMeeting.name,
    (rel) => rel,
    () => null);

  const openSchedulerModal = () => {
    openModal(modalConsts.clientSchedulerModal, [{
      link: scheduleMeetingRel.link('related').url(),
    }]);
  };

  return (
    <RoadmapDeliverableWrapperLayout
      handleNextOverride={scheduleMeetingRel ? openSchedulerModal : goToDashboard}
      primaryActionLabelOverride={scheduleMeetingRel ? scheduleMeetingRel.meta('prompt') : undefined}
    >
      <FDStack direction={'column'} spacing={5} minWidth={500}>
        <NextMeetingScheduleInfo />
        {!scheduleMeetingRel ? <FDAlert
          status={'warning'}
          title={resource.attr('joinWarning')}
          description={resource.attr('joinWarningDescription')}
          {...dataAttrs('join-warning')}
        /> : null}
        <FDPaper padding={3} appearance={'flat'} {...dataAttrs('next-meeting-agenda-info')}>
          <FDStack direction={'column'} spacing={4}>
            <MetaControlField attr={'nextMeetingAgendaTitle'} />
            <RoadmapDeliverableTimeline timelineItems={resource.attr('agendaItems').resources().list()} />
          </FDStack>
        </FDPaper>
      </FDStack>
    </RoadmapDeliverableWrapperLayout>
  );
};

export default Layout;
